import { Calendar } from "@/models/date-picker/Calendar";

export const INPUT_HEIGHT = 35;
export const POPUP_WIDTH = 700;
export const POPUP_HEIGHT = 335;
export const INPUT_POPUP_DISTANCE = 10;

export enum InputTextAlign {
  Left = "left",
  Center = "center"
}

export enum PopupAlign {
  Left = "left",
  Center = "center",
  Right = "right"
}

export class DatePicker {
  constructor(
    public readonly calendars: Calendar[],
    public readonly previousMonthCalendar: Calendar,
    public readonly nextMonthCalendar: Calendar,
    public readonly previousYearCalendar: Calendar,
    public readonly nextYearCalendar: Calendar
  ) {}

  public static build(date: Date, monthsAgo: number = 3): DatePicker {
    return new DatePicker(
      buildMonthsAgoCalendar(date, monthsAgo),
      Calendar.buildPreviousMonthCalendar(date, monthsAgo),
      Calendar.buildNextMonthCalendar(date, 1),
      Calendar.buildPreviousYearCalendar(date),
      Calendar.buildNextYearCalendar(date)
    );
  }
}

/**
 * monthsAgo分のCalendarを生成する
 */
function buildMonthsAgoCalendar(date: Date, monthsAgo: number): Calendar[] {
  const calendars: Calendar[] = [];

  for (let i = 0; i < monthsAgo; i++) {
    const index = monthsAgo - 1 - i;
    calendars.push(Calendar.buildPreviousMonthCalendar(date, index));
  }

  return calendars;
}
